import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

const NotFoundPage: React.FC = () => {
  return (
    <div className="not-found">
      <h1>404 - ページが見つかりません</h1>
      <p>申し訳ありません。お探しのページは存在しません。</p>
      <Link to="/tf/user-sheets">ホームに戻る</Link>
    </div>
  );
};

export default NotFoundPage;
